// import { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import { useSettings } from "../context/SettingsContext";
// import { apiJson } from "../api/apiClient";
// import "../styles/PaymentPage.css";

// const makeFmt =
//   (symbol = "₹") =>
//   (n) => {
//     if (n == null || n === "") return "—";
//     return symbol + parseFloat(n).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//   };

// function loadRazorpay() {
//   return new Promise((resolve) => {
//     if (window.Razorpay) return resolve(true);
//     const s = document.createElement("script");
//     s.src = "https://checkout.razorpay.com/v1/checkout.js";
//     s.onload = () => resolve(true);
//     s.onerror = () => resolve(false);
//     document.body.appendChild(s);
//   });
// }

// function loadStripe(publishableKey) {
//   return new Promise((resolve) => {
//     if (window.Stripe) return resolve(window.Stripe(publishableKey));
//     const s = document.createElement("script");
//     s.src = "https://js.stripe.com/v3/";
//     s.onload = () => resolve(window.Stripe(publishableKey));
//     s.onerror = () => resolve(null);
//     document.body.appendChild(s);
//   });
// }

// const ElegantRow = ({ label, value, accent, bold, borderTop }) => (
//   <div className={`payment-row ${borderTop ? "payment-row-border-top" : ""}`}>
//     <span className="payment-row-label" style={{ color: accent, fontWeight: bold ? "700" : "400" }}>
//       {label}
//     </span>
//     <span className="payment-row-value" style={{ color: accent, fontWeight: bold ? "800" : "400" }}>
//       {value}
//     </span>
//   </div>
// );

// // Manual payment form — client submits, always pending admin approval.
// const ManualPaymentForm = ({ amountDue, fmt, submitting, onSubmit, onCancel }) => {
//   const [mode, setMode] = useState("cash");
//   const [reference, setReference] = useState("");
//   const [notes, setNotes] = useState("");

//   return (
//     <div className="payment-manual-form">
//       <div className="payment-section-title" style={{ marginBottom: "12px" }}>
//         🏦 Pay Manually
//       </div>

//       <div style={{ marginBottom: "12px" }}>
//         <label className="payment-manual-label">Payment Mode</label>
//         <select value={mode} onChange={(e) => setMode(e.target.value)} className="payment-manual-select">
//           <option value="cash">💵 Cash</option>
//           <option value="cheque">📄 Cheque</option>
//           <option value="bank_transfer">🏦 Bank Transfer</option>
//         </select>
//       </div>

//       <div style={{ marginBottom: "12px" }}>
//         <label className="payment-manual-label">
//           Reference Number <span style={{ fontWeight: 400, color: "var(--text-muted)" }}>(cheque no. / transaction ref)</span>
//         </label>
//         <input
//           type="text"
//           value={reference}
//           onChange={(e) => setReference(e.target.value)}
//           placeholder="Optional"
//           className="payment-manual-input"
//         />
//       </div>

//       <div style={{ marginBottom: "16px" }}>
//         <label className="payment-manual-label">Notes</label>
//         <textarea
//           value={notes}
//           onChange={(e) => setNotes(e.target.value)}
//           placeholder="Any additional details…"
//           rows={2}
//           className="payment-manual-textarea"
//         />
//       </div>

//       <div className="payment-manual-amount-note">
//         Amount: <strong>{fmt(amountDue)}</strong>
//         <div style={{ fontSize: "11px", color: "var(--text-muted)", marginTop: "4px" }}>
//           This will be submitted for admin approval and won't be marked as paid immediately.
//         </div>
//       </div>

//       <button
//         className="payment-btn payment-btn-primary"
//         onClick={() => onSubmit({ payment_mode: mode, reference_number: reference, notes })}
//         disabled={submitting}
//       >
//         {submitting ? (
//           <span className="payment-btn-spinner">
//             <span className="spinner"></span>
//             Submitting…
//           </span>
//         ) : (
//           "Submit for Approval"
//         )}
//       </button>

//       <button className="payment-btn-secondary" onClick={onCancel} disabled={submitting}>
//         ← Back
//       </button>
//     </div>
//   );
// };

// // ── Main Public (no-login) Payment Page ─────────────────────────────
// export default function PublicPaymentPage() {
//   const { tenant, bookingId } = useParams();
//   const { settings } = useSettings(); 

//   const primaryColor = settings?.primary_color || "#c9a96e";
//   const logoUrl = settings?.logo_dark_url || settings?.logo_light_url || null;
//   const appName = settings?.tenant_name || "Property Booking";

//   const [currency, setCurrency] = useState({ symbol: "₹" });
//   const fmt = (n) => makeFmt(currency.symbol)(n);

//   const [booking, setBooking] = useState(null);
//   const [milestone, setMilestone] = useState(null);
//   const [gateway, setGateway] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [paying, setPaying] = useState(false);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState(false);
//   const [confirming, setConfirming] = useState(false);

//   const [payMode, setPayMode] = useState("online");
//   const [manualSubmitting, setManualSubmitting] = useState(false);
//   const [manualSubmitted, setManualSubmitted] = useState(false);

//   const params = new URLSearchParams(window.location.search);
//   const milestoneId = params.get("milestone");
//   const expires = params.get("expires");
//   const sig = params.get("sig");
//   const sessionId = params.get("session_id"); // present when Stripe redirects back
//   const linkQs = `?expires=${expires || ""}&sig=${sig || ""}${milestoneId ? `&milestone=${milestoneId}` : ""}`;

//   const isMilestonePayment = !!milestone;

//   // Tenant currency — same public endpoint the dashboard already uses.
//   useEffect(() => {
//     if (!tenant) return;
//     apiJson(tenant, `/currency`)
//       .then((d) => d && setCurrency({ symbol: d.symbol || "₹" }))
//       .catch(() => {});
//   }, [tenant]);

//   useEffect(() => {
//     if (!bookingId || !tenant) return;

//     (async () => {
//       try {
//         const [bData, gData] = await Promise.all([
//           apiJson(tenant, `/bookings/${bookingId}/public?expires=${expires}&sig=${sig}${milestoneId ? `&milestone=${milestoneId}` : ""}`),
//           apiJson(tenant, `/payment/config-public`).catch(() => null),
//         ]);

//         setBooking(bData.booking);
//         setGateway(gData);

//         if (bData.booking?.booking_status === "confirmed" && !milestoneId) {
//           setSuccess(true);
//           setLoading(false);
//           return;
//         }

//         if (milestoneId) {
//           const mData = await apiJson(
//             tenant,
//             `/bookings/${bookingId}/milestones-public?expires=${expires}&sig=${sig}&milestone=${milestoneId}`,
//           );
//           const found = (mData.milestones || []).find((m) => String(m.id) === String(milestoneId));
//           if (!found) throw new Error("Milestone not found.");
//           if (found.status === "paid") setError("This milestone has already been paid.");
//           setMilestone(found);
//         }

//         // Returning from Stripe checkout — finish confirmation automatically.
//         if (sessionId) {
//           setConfirming(true);
//           try {
//             await apiJson(tenant, `/payment/stripe/public-confirm`, {
//               method: "POST",
//               headers: { "Content-Type": "application/json", Accept: "application/json" },
//               body: JSON.stringify({
//                 booking_id: bookingId,
//                 session_id: sessionId,
//                 milestone_id: milestoneId || undefined,
//                 expires,
//                 sig,
//               }),
//             });
//             setSuccess(true);
//           } catch (confirmErr) {
//             setError(confirmErr.message || "Could not confirm payment.");
//           } finally {
//             setConfirming(false);
//           }
//         }
//       } catch (e) {
//         setError(e.message || "This payment link is invalid or has expired.");
//       } finally {
//         setLoading(false);
//       }
//     })();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [tenant, bookingId, milestoneId, expires, sig, sessionId]);

//   const fmtAmt = (n) => fmt(n);

//   const downPayment = isMilestonePayment
//     ? milestone?.total_with_tax ?? milestone?.amount
//     : booking?.down_payment_amount || booking?.total_amount || parseFloat(booking?.price || 0);

//   // Same fallback chain as the authenticated PaymentPage.jsx: prefer a flat
//   // column if the booking has one, otherwise fall back to the loaded
//   // relation. Guards against either being missing from the API response.
//   const projectLabel = booking?.project_name || booking?.project?.project_name || "—";
//   const floorLabel = booking?.block_name || booking?.block?.block_name || booking?.block || "—";

//   const payWithRazorpay = async () => {
//     setPaying(true);
//     setError("");

//     const ok = await loadRazorpay();
//     if (!ok) {
//       setError("Razorpay failed to load. Please check your internet connection.");
//       setPaying(false);
//       return;
//     }

//     try {
//       const data = await apiJson(tenant, `/payment/razorpay/public-create-order`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json", Accept: "application/json" },
//         body: JSON.stringify({
//           booking_id: bookingId,
//           milestone_id: milestoneId || undefined,
//           expires,
//           sig,
//         }),
//       });

//       if (!data.order_id) throw new Error("No order ID received from server");
//       if (!gateway?.key) throw new Error("Razorpay key not configured");

//       const options = {
//         key: gateway.key,
//         amount: data.amount,
//         currency: data.currency || "INR",
//         name: data.app_name || appName,
//         description: isMilestonePayment
//           ? `${milestone.label} · Unit ${booking?.plot_number}`
//           : `Unit ${booking?.plot_number} — Booking #${bookingId}`,
//         order_id: data.order_id,
//         prefill: {
//           name: booking?.client_name || "",
//           email: booking?.client_email || "",
//         },
//         theme: { color: primaryColor },
//         handler: async (response) => {
//           try {
//             await apiJson(tenant, `/payment/razorpay/public-verify`, {
//               method: "POST",
//               headers: { "Content-Type": "application/json", Accept: "application/json" },
//               body: JSON.stringify({
//                 ...response,
//                 booking_id: bookingId,
//                 milestone_id: milestoneId || undefined,
//                 expires,
//                 sig,
//               }),
//             });
//             setSuccess(true);
//             setPaying(false);
//           } catch (err) {
//             setError(err.message);
//             setPaying(false);
//           }
//         },
//         modal: {
//           ondismiss: () => {
//             setPaying(false);
//             setError("Payment was cancelled.");
//           },
//         },
//       };

//       const razorpay = new window.Razorpay(options);
//       razorpay.open();
//     } catch (err) {
//       setError(err.message);
//       setPaying(false);
//     }
//   };

//   const payWithStripe = async () => {
//     setPaying(true);
//     setError("");
//     try {
//       const stripe = await loadStripe(gateway.key);
//       if (!stripe) throw new Error("Stripe failed to load.");

//       const data = await apiJson(tenant, `/payment/stripe/public-checkout`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json", Accept: "application/json" },
//         body: JSON.stringify({
//           booking_id: bookingId,
//           milestone_id: milestoneId || undefined,
//           expires,
//           sig,
//         }),
//       });

//       const { error: stripeError } = await stripe.redirectToCheckout({ sessionId: data.session_id });
//       if (stripeError) throw new Error(stripeError.message);
//     } catch (err) {
//       setError(err.message);
//       setPaying(false);
//     }
//   };

//   const payWithPhonePe = async () => {
//     setPaying(true);
//     setError("");
//     try {
//       const data = await apiJson(tenant, `/payment/phonepe/public-initiate`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json", Accept: "application/json" },
//         body: JSON.stringify({
//           booking_id: bookingId,
//           milestone_id: milestoneId || undefined,
//           expires,
//           sig,
//         }),
//       });
//       window.location.href = data.redirect_url;
//     } catch (err) {
//       setError(err.message);
//       setPaying(false);
//     }
//   };

//   const handlePay = () => {
//     if (!gateway) {
//       setError("No payment gateway configured.");
//       return;
//     }
//     const p = gateway.provider?.toLowerCase();
//     if (p === "razorpay") payWithRazorpay();
//     else if (p === "stripe") payWithStripe();
//     else if (p === "phonepe") payWithPhonePe();
//     else setError(`Unknown payment provider: ${gateway.provider}`);
//   };

//   const submitManualPayment = async ({ payment_mode, reference_number, notes }) => {
//     setManualSubmitting(true);
//     setError("");
//     try {
//       await apiJson(tenant, `/bookings/${bookingId}/manual-payment${linkQs}`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json", Accept: "application/json" },
//         body: JSON.stringify({
//           payment_mode,
//           reference_number: reference_number || undefined,
//           notes: notes || undefined,
//           milestone_id: milestoneId || undefined,
//           amount: downPayment,
//           expires,
//           sig,
//         }),
//       });
//       setManualSubmitted(true);
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setManualSubmitting(false);
//     }
//   };

//   const providerLabel = gateway?.provider
//     ? { razorpay: "Pay with Razorpay", stripe: "Pay with Stripe", phonepe: "Pay with PhonePe" }[gateway.provider.toLowerCase()] ||
//       "Proceed to Pay"
//     : "Proceed to Pay";

//   // ── Self-contained theme tokens ─────────────────────────────────────
//   // PaymentPage.css references --page-bg, --card-bg, --card-border,
//   // --text-dark, --text-muted, --primary-color. This page must not assume
//   // a parent layout has already defined them (e.g. if this route isn't
//   // nested inside the same wrapper as the authenticated dashboard/payment
//   // routes) — so every token gets a concrete fallback right here, on the
//   // outermost element, guaranteeing correct rendering regardless of where
//   // this route sits in the router tree.
//   const themeVars = {
//     "--primary-color": primaryColor,
//     "--page-bg": settings?.page_bg_color || "#f7f6f3",
//     "--card-bg": settings?.card_bg_color || "#ffffff",
//     "--card-border": settings?.card_border_color || "#e6e2d8",
//     "--text-dark": settings?.text_dark_color || "#1f2430",
//     "--text-muted": settings?.text_muted_color || "#6b7280",
//   };

//   // ── Branding header shown above every state ─────────────────────────
//   const BrandHeader = () => (
//     <div style={{ textAlign: "center", marginBottom: 20 }}>
//       {logoUrl ? (
//         <img
//           src={logoUrl}
//           alt={appName}
//           style={{ maxHeight: 40, margin: "0 auto 8px", display: "block" }}
//           onError={(e) => {
//             e.currentTarget.style.display = "none";
//           }}
//         />
//       ) : (
//         <div style={{ fontSize: 18, fontWeight: 800, color: primaryColor, marginBottom: 8 }}>{appName}</div>
//       )}
//     </div>
//   );

//   // ── States ────────────────────────────────────────────────────────
//   if (loading || confirming)
//     return (
//       <div className="payment-page public-payment-page" style={themeVars}>
//         <BrandHeader />
//         <div className="payment-loading">
//           <div className="payment-loading-spinner">⏳</div>
//           <div className="payment-loading-text">{confirming ? "Confirming your payment…" : "Loading payment details…"}</div>
//         </div>
//       </div>
//     );

//   if (manualSubmitted)
//     return (
//       <div className="payment-page public-payment-page" style={themeVars}>
//         <BrandHeader />
//         <div className="payment-card payment-card-centered">
//           <div className="payment-success-icon">⏳</div>
//           <div className="payment-error-title">Submitted for Approval</div>
//           <div className="payment-success-message">
//             Your manual payment for Unit <strong style={{ color: primaryColor }}>{booking?.plot_number}</strong> has been
//             submitted and is awaiting confirmation. You'll be notified once it's approved.
//           </div>
//         </div>
//       </div>
//     );

//   if (success)
//     return (
//       <div className="payment-page public-payment-page" style={themeVars}>
//         <BrandHeader />
//         <div className="payment-card-success payment-card-centered">
//           <div className="payment-success-icon">🎉</div>
//           <div className="payment-success-title">Payment Successful!</div>
//           <div className="payment-success-message">
//             {isMilestonePayment ? (
//               <>
//                 Payment for <strong style={{ color: primaryColor }}>{milestone?.label}</strong> on Unit{" "}
//                 <strong style={{ color: primaryColor }}>{booking?.plot_number}</strong> confirmed.
//               </>
//             ) : (
//               <>
//                 Unit <strong style={{ color: primaryColor }}>{booking?.plot_number}</strong> booking confirmed. A receipt
//                 will be sent to your email.
//               </>
//             )}
//           </div>
//           <div className="payment-details-box">
//             {[
//               ["Booking ID", `#${bookingId}`],
//               ["Unit", booking?.plot_number],
//               ...(isMilestonePayment ? [["Milestone", milestone?.label]] : []),
//               ["Amount Paid", fmtAmt(downPayment)],
//             ].map(([k, v]) => (
//               <div key={k} className="payment-detail-row">
//                 <span className="payment-detail-label">{k}</span>
//                 <span className={k === "Amount Paid" ? "payment-detail-highlight" : "payment-detail-value"}>{v}</span>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     );

//   if (error && !booking)
//     return (
//       <div className="payment-page public-payment-page" style={themeVars}>
//         <BrandHeader />
//         <div className="payment-card-error payment-card-centered">
//           <div className="payment-error-icon-large">⚠️</div>
//           <div className="payment-error-message">{error}</div>
//           <div style={{ fontSize: 13, color: "var(--text-muted)", marginTop: 12 }}>
//             Please contact your agent or the property team for a new payment link.
//           </div>
//         </div>
//       </div>
//     );

//   // ── Main form ────────────────────────────────────────────────────
//   return (
//     <div className="payment-page public-payment-page" style={themeVars}>
//       <BrandHeader />
//       <div className="payment-card">
//         <div className="payment-header" style={{ color: primaryColor }}>
//           {isMilestonePayment ? "Milestone Payment" : "Complete Your Booking"}
//         </div>
//         <div className="payment-subheader">
//           {isMilestonePayment
//             ? `${milestone.label} · Booking #${bookingId} · Unit ${booking?.plot_number}`
//             : `Booking #${bookingId} · ${booking?.plot_type} — Unit ${booking?.plot_number}`}
//         </div>

//         <div className="payment-summary">
//           <div className="payment-section-title">📋 Booking Summary</div>
//           <div className="payment-summary-content">
//             {[
//               ["Project", projectLabel],
//               ["Floor", floorLabel],
//               ["Area", booking?.area ? `${booking.area} sq.ft` : "—"],
//             ].map(([k, v]) => (
//               <div key={k} className="payment-summary-row">
//                 <span className="payment-summary-label">{k}</span>
//                 <span className="payment-summary-value">{v}</span>
//               </div>
//             ))}
//           </div>
//         </div>

//         {isMilestonePayment && (
//           <div className="payment-milestone-card">
//             <div className="payment-milestone-header">💳 Milestone Payment</div>
//             <ElegantRow label={`${milestone.label} (base)`} value={fmtAmt(milestone.amount)} accent="var(--text-muted)" />
//             {(milestone.extra_fees || 0) > 0 && (
//               <ElegantRow label="Additional Fees" value={fmtAmt(milestone.extra_fees)} accent="var(--text-muted)" />
//             )}
//             {(milestone.tax_amount || 0) > 0 && (
//               <ElegantRow
//                 label={`${milestone.tax_label || "Tax"}${milestone.tax_rate > 0 ? ` (${milestone.tax_rate}%)` : ""}`}
//                 value={fmtAmt(milestone.tax_amount)}
//                 accent="#f59e0b"
//                 borderTop
//               />
//             )}
//             <ElegantRow
//               label="Milestone Total"
//               value={fmtAmt(milestone.total_with_tax ?? milestone.amount)}
//               accent={primaryColor}
//               bold
//               borderTop
//             />
//           </div>
//         )}

//         <div className="payment-amount-section">
//           <div className="payment-amount-label">{isMilestonePayment ? milestone.label : "Total amount due"}</div>
//           <div className="payment-amount-value" style={{ color: primaryColor }}>
//             {fmtAmt(downPayment)}
//           </div>
//         </div>

//         {error && (
//           <div className="payment-error">
//             <span className="payment-error-icon">⚠</span>
//             {error}
//           </div>
//         )}

//         <div className="payment-mode-tabs">
//           <button
//             className={`payment-mode-tab ${payMode === "online" ? "payment-mode-tab-active" : ""}`}
//             onClick={() => setPayMode("online")}
//           >
//             💳 Pay Online
//           </button>
//           <button
//             className={`payment-mode-tab ${payMode === "manual" ? "payment-mode-tab-active" : ""}`}
//             onClick={() => setPayMode("manual")}
//           >
//             🏦 Pay Manually
//           </button>
//         </div>

//         {payMode === "online" ? (
//           <>
//             {!gateway && (
//               <div className="payment-gateway-warning">⚠ No payment gateway configured. Please contact your agent.</div>
//             )}
//             <button
//               className="payment-btn payment-btn-primary"
//               onClick={handlePay}
//               disabled={paying || !gateway}
//               style={{ background: primaryColor }}
//             >
//               {paying ? (
//                 <span className="payment-btn-spinner">
//                   <span className="spinner"></span>
//                   Processing...
//                 </span>
//               ) : (
//                 providerLabel
//               )}
//             </button>
//           </>
//         ) : (
//           <ManualPaymentForm
//             amountDue={downPayment}
//             fmt={fmtAmt}
//             submitting={manualSubmitting}
//             onSubmit={submitManualPayment}
//             onCancel={() => setPayMode("online")}
//           />
//         )}
//       </div>
//     </div>
//   );
// }

import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSettings } from "../context/SettingsContext";
import { apiJson } from "../api/apiClient";
import "../styles/PaymentPage.css";

const makeFmt =
  (symbol = "₹") =>
  (n) => {
    if (n == null || n === "") return "—";
    return symbol + parseFloat(n).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

function loadRazorpay() {
  return new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}

function loadStripe(publishableKey) {
  return new Promise((resolve) => {
    if (window.Stripe) return resolve(window.Stripe(publishableKey));
    const s = document.createElement("script");
    s.src = "https://js.stripe.com/v3/";
    s.onload = () => resolve(window.Stripe(publishableKey));
    s.onerror = () => resolve(null);
    document.body.appendChild(s);
  });
}

const ElegantRow = ({ label, value, accent, bold, borderTop }) => (
  <div className={`payment-row ${borderTop ? "payment-row-border-top" : ""}`}>
    <span className="payment-row-label" style={{ color: accent, fontWeight: bold ? "700" : "400" }}>
      {label}
    </span>
    <span className="payment-row-value" style={{ color: accent, fontWeight: bold ? "800" : "400" }}>
      {value}
    </span>
  </div>
);

// Manual payment form — client submits, always pending admin approval.
const ManualPaymentForm = ({ amountDue, fmt, submitting, onSubmit, onCancel }) => {
  const [mode, setMode] = useState("cash");
  const [reference, setReference] = useState("");
  const [notes, setNotes] = useState("");

  return (
    <div className="payment-manual-form">
      <div className="payment-section-title" style={{ marginBottom: "12px" }}>
        🏦 Pay Manually
      </div>

      <div style={{ marginBottom: "12px" }}>
        <label className="payment-manual-label">Payment Mode</label>
        <select value={mode} onChange={(e) => setMode(e.target.value)} className="payment-manual-select">
          <option value="cash">💵 Cash</option>
          <option value="cheque">📄 Cheque</option>
          <option value="bank_transfer">🏦 Bank Transfer</option>
        </select>
      </div>

      <div style={{ marginBottom: "12px" }}>
        <label className="payment-manual-label">
          Reference Number <span style={{ fontWeight: 400, color: "var(--text-muted)" }}>(cheque no. / transaction ref)</span>
        </label>
        <input
          type="text"
          value={reference}
          onChange={(e) => setReference(e.target.value)}
          placeholder="Optional"
          className="payment-manual-input"
        />
      </div>

      <div style={{ marginBottom: "16px" }}>
        <label className="payment-manual-label">Notes</label>
        <textarea
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder="Any additional details…"
          rows={2}
          className="payment-manual-textarea"
        />
      </div>

      <div className="payment-manual-amount-note">
        Amount: <strong>{fmt(amountDue)}</strong>
        <div style={{ fontSize: "11px", color: "var(--text-muted)", marginTop: "4px" }}>
          This will be submitted for admin approval and won't be marked as paid immediately.
        </div>
      </div>

      <button
        className="payment-btn payment-btn-primary"
        onClick={() => onSubmit({ payment_mode: mode, reference_number: reference, notes })}
        disabled={submitting}
      >
        {submitting ? (
          <span className="payment-btn-spinner">
            <span className="spinner"></span>
            Submitting…
          </span>
        ) : (
          "Submit for Approval"
        )}
      </button>

      <button className="payment-btn-secondary" onClick={onCancel} disabled={submitting}>
        ← Back
      </button>
    </div>
  );
};

// ── Main Public (no-login) Payment Page ─────────────────────────────
export default function PublicPaymentPage() {
  const { tenant, bookingId } = useParams();
  const { settings } = useSettings();

  const primaryColor = settings?.primary_color || "#c9a96e";
  const logoUrl = settings?.app_logo_dark_url || settings?.app_logo_light_url || null;
  const appName = settings?.app_name || "Property Booking";

  const [currency, setCurrency] = useState({ symbol: "₹" });
  const fmt = (n) => makeFmt(currency.symbol)(n);

  const [booking, setBooking] = useState(null);
  const [milestone, setMilestone] = useState(null);
  const [gateway, setGateway] = useState(null);
  const [loading, setLoading] = useState(true);
  const [paying, setPaying] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [confirming, setConfirming] = useState(false);

  const [payMode, setPayMode] = useState("online");
  const [manualSubmitting, setManualSubmitting] = useState(false);
  const [manualSubmitted, setManualSubmitted] = useState(false);

  const params = new URLSearchParams(window.location.search);
  const milestoneId = params.get("milestone");
  const expires = params.get("expires");
  const sig = params.get("sig");
  const sessionId = params.get("session_id"); // present when Stripe redirects back
  const linkQs = `?expires=${expires || ""}&sig=${sig || ""}${milestoneId ? `&milestone=${milestoneId}` : ""}`;

  const isMilestonePayment = !!milestone;
  const alreadyPaid = milestone?.status === "paid";

  // Tenant currency — same public endpoint the dashboard already uses.
  useEffect(() => {
    if (!tenant) return;
    apiJson(tenant, `/currency`)
      .then((d) => d && setCurrency({ symbol: d.symbol || "₹" }))
      .catch(() => {});
  }, [tenant]);

  useEffect(() => {
    if (!bookingId || !tenant) return;

    (async () => {
      try {
        const [bData, gData] = await Promise.all([
          apiJson(tenant, `/bookings/${bookingId}/public?expires=${expires}&sig=${sig}${milestoneId ? `&milestone=${milestoneId}` : ""}`),
          apiJson(tenant, `/payment/config-public`).catch(() => null),
        ]);

        setBooking(bData.booking);
        setGateway(gData);

        if (bData.booking?.booking_status === "confirmed" && !milestoneId) {
          setSuccess(true);
          setLoading(false);
          return;
        }

        if (milestoneId) {
          const mData = await apiJson(
            tenant,
            `/bookings/${bookingId}/milestones-public?expires=${expires}&sig=${sig}&milestone=${milestoneId}`,
          );
          const found = (mData.milestones || []).find((m) => String(m.id) === String(milestoneId));
          if (!found) throw new Error("Milestone not found.");
          if (found.status === "paid") setError("This milestone has already been paid.");
          setMilestone(found);
        }

        // Returning from Stripe checkout — finish confirmation automatically.
        if (sessionId) {
          setConfirming(true);
          try {
            await apiJson(tenant, `/payment/stripe/public-confirm`, {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({
                booking_id: bookingId,
                session_id: sessionId,
                milestone_id: milestoneId || undefined,
                expires,
                sig,
              }),
            });
            setSuccess(true);
          } catch (confirmErr) {
            setError(confirmErr.message || "Could not confirm payment.");
          } finally {
            setConfirming(false);
          }
        }
      } catch (e) {
        setError(e.message || "This payment link is invalid or has expired.");
      } finally {
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenant, bookingId, milestoneId, expires, sig, sessionId]);

  const fmtAmt = (n) => fmt(n);

  const downPayment = isMilestonePayment
    ? milestone?.total_with_tax ?? milestone?.amount
    : booking?.down_payment_amount || booking?.total_amount || parseFloat(booking?.price || 0);

  // Same fallback chain as the authenticated PaymentPage.jsx: prefer a flat
  // column if the booking has one, otherwise fall back to the loaded
  // relation. Guards against either being missing from the API response.
  const projectLabel = booking?.project_name || booking?.project?.project_name || "—";
  const floorLabel = booking?.block_name || booking?.block?.block_name || booking?.block || "—";

  const payWithRazorpay = async () => {
    setPaying(true);
    setError("");

    const ok = await loadRazorpay();
    if (!ok) {
      setError("Razorpay failed to load. Please check your internet connection.");
      setPaying(false);
      return;
    }

    try {
      const data = await apiJson(tenant, `/payment/razorpay/public-create-order`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          booking_id: bookingId,
          milestone_id: milestoneId || undefined,
          expires,
          sig,
        }),
      });

      if (!data.order_id) throw new Error("No order ID received from server");
      if (!gateway?.key) throw new Error("Razorpay key not configured");

      const options = {
        key: gateway.key,
        amount: data.amount,
        currency: data.currency || "INR",
        name: data.app_name || appName,
        description: isMilestonePayment
          ? `${milestone.label} · Unit ${booking?.plot_number}`
          : `Unit ${booking?.plot_number} — Booking #${bookingId}`,
        order_id: data.order_id,
        prefill: {
          name: booking?.client_name || "",
          email: booking?.client_email || "",
        },
        theme: { color: primaryColor },
        handler: async (response) => {
          try {
            await apiJson(tenant, `/payment/razorpay/public-verify`, {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({
                ...response,
                booking_id: bookingId,
                milestone_id: milestoneId || undefined,
                expires,
                sig,
              }),
            });
            setSuccess(true);
            setPaying(false);
          } catch (err) {
            setError(err.message);
            setPaying(false);
          }
        },
        modal: {
          ondismiss: () => {
            setPaying(false);
            setError("Payment was cancelled.");
          },
        },
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();
    } catch (err) {
      setError(err.message);
      setPaying(false);
    }
  };

  const payWithStripe = async () => {
    setPaying(true);
    setError("");
    try {
      const stripe = await loadStripe(gateway.key);
      if (!stripe) throw new Error("Stripe failed to load.");

      const data = await apiJson(tenant, `/payment/stripe/public-checkout`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          booking_id: bookingId,
          milestone_id: milestoneId || undefined,
          expires,
          sig,
        }),
      });

      const { error: stripeError } = await stripe.redirectToCheckout({ sessionId: data.session_id });
      if (stripeError) throw new Error(stripeError.message);
    } catch (err) {
      setError(err.message);
      setPaying(false);
    }
  };

  const payWithPhonePe = async () => {
    setPaying(true);
    setError("");
    try {
      const data = await apiJson(tenant, `/payment/phonepe/public-initiate`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          booking_id: bookingId,
          milestone_id: milestoneId || undefined,
          expires,
          sig,
        }),
      });
      window.location.href = data.redirect_url;
    } catch (err) {
      setError(err.message);
      setPaying(false);
    }
  };

  const handlePay = () => {
    if (!gateway) {
      setError("No payment gateway configured.");
      return;
    }
    const p = gateway.provider?.toLowerCase();
    if (p === "razorpay") payWithRazorpay();
    else if (p === "stripe") payWithStripe();
    else if (p === "phonepe") payWithPhonePe();
    else setError(`Unknown payment provider: ${gateway.provider}`);
  };

  const submitManualPayment = async ({ payment_mode, reference_number, notes }) => {
    setManualSubmitting(true);
    setError("");
    try {
      await apiJson(tenant, `/bookings/${bookingId}/manual-payment${linkQs}`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          payment_mode,
          reference_number: reference_number || undefined,
          notes: notes || undefined,
          milestone_id: milestoneId || undefined,
          amount: downPayment,
          expires,
          sig,
        }),
      });
      setManualSubmitted(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setManualSubmitting(false);
    }
  };

  const providerLabel = gateway?.provider
    ? { razorpay: "Pay with Razorpay", stripe: "Pay with Stripe", phonepe: "Pay with PhonePe" }[gateway.provider.toLowerCase()] ||
      "Proceed to Pay"
    : "Proceed to Pay";

  // ── Self-contained theme tokens ─────────────────────────────────────
  // PaymentPage.css references --page-bg, --card-bg, --card-border,
  // --text-dark, --text-muted, --primary-color. This page must not assume
  // a parent layout has already defined them (e.g. if this route isn't
  // nested inside the same wrapper as the authenticated dashboard/payment
  // routes) — so every token gets a concrete fallback right here, on the
  // outermost element, guaranteeing correct rendering regardless of where
  // this route sits in the router tree.
  const themeVars = {
    "--primary-color": primaryColor,
    "--page-bg": settings?.page_bg_color || "#f7f6f3",
    "--card-bg": settings?.card_bg_color || "#ffffff",
    "--card-border": settings?.card_border_color || "#e6e2d8",
    "--text-dark": settings?.text_dark_color || "#1f2430",
    "--text-muted": settings?.text_muted_color || "#6b7280",
  };

  // ── Branding header shown above every state ─────────────────────────
  const BrandHeader = () => (
    <div style={{ textAlign: "center", marginBottom: 20 }}>
      {logoUrl ? (
        <img
          src={logoUrl}
          alt={appName}
          style={{ maxHeight: 40, margin: "0 auto 8px", display: "block" }}
          onError={(e) => {
            e.currentTarget.style.display = "none";
          }}
        />
      ) : (
        <div style={{ fontSize: 18, fontWeight: 800, color: primaryColor, marginBottom: 8 }}>{appName}</div>
      )}
    </div>
  );

  // ── States ────────────────────────────────────────────────────────
  if (loading || confirming)
    return (
      <div className="payment-page public-payment-page" style={themeVars}>
        <BrandHeader />
        <div className="payment-loading">
          <div className="payment-loading-spinner">⏳</div>
          <div className="payment-loading-text">{confirming ? "Confirming your payment…" : "Loading payment details…"}</div>
        </div>
      </div>
    );

  if (manualSubmitted)
    return (
      <div className="payment-page public-payment-page" style={themeVars}>
        <BrandHeader />
        <div className="payment-card payment-card-centered">
          <div className="payment-success-icon">⏳</div>
          <div className="payment-error-title">Submitted for Approval</div>
          <div className="payment-success-message">
            Your manual payment for Unit <strong style={{ color: primaryColor }}>{booking?.plot_number}</strong> has been
            submitted and is awaiting confirmation. You'll be notified once it's approved.
          </div>
        </div>
      </div>
    );

  if (success)
    return (
      <div className="payment-page public-payment-page" style={themeVars}>
        <BrandHeader />
        <div className="payment-card-success payment-card-centered">
          <div className="payment-success-icon">🎉</div>
          <div className="payment-success-title">Payment Successful!</div>
          <div className="payment-success-message">
            {isMilestonePayment ? (
              <>
                Payment for <strong style={{ color: primaryColor }}>{milestone?.label}</strong> on Unit{" "}
                <strong style={{ color: primaryColor }}>{booking?.plot_number}</strong> confirmed.
              </>
            ) : (
              <>
                Unit <strong style={{ color: primaryColor }}>{booking?.plot_number}</strong> booking confirmed. A receipt
                will be sent to your email.
              </>
            )}
          </div>
          <div className="payment-details-box">
            {[
              ["Booking ID", `#${bookingId}`],
              ["Unit", booking?.plot_number],
              ...(isMilestonePayment ? [["Milestone", milestone?.label]] : []),
              ["Amount Paid", fmtAmt(downPayment)],
            ].map(([k, v]) => (
              <div key={k} className="payment-detail-row">
                <span className="payment-detail-label">{k}</span>
                <span className={k === "Amount Paid" ? "payment-detail-highlight" : "payment-detail-value"}>{v}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    );

  if (error && !booking)
    return (
      <div className="payment-page public-payment-page" style={themeVars}>
        <BrandHeader />
        <div className="payment-card-error payment-card-centered">
          <div className="payment-error-icon-large">⚠️</div>
          <div className="payment-error-message">{error}</div>
          <div style={{ fontSize: 13, color: "var(--text-muted)", marginTop: 12 }}>
            Please contact your agent or the property team for a new payment link.
          </div>
        </div>
      </div>
    );

  // ── Main form ────────────────────────────────────────────────────
  return (
    <div className="payment-page public-payment-page" style={themeVars}>
      <BrandHeader />
      <div className="payment-card">
        <div className="payment-header" style={{ color: primaryColor }}>
          {isMilestonePayment ? "Milestone Payment" : "Complete Your Booking"}
        </div>
        <div className="payment-subheader">
          {isMilestonePayment
            ? `${milestone.label} · Booking #${bookingId} · Unit ${booking?.plot_number}`
            : `Booking #${bookingId} · ${booking?.plot_type} — Unit ${booking?.plot_number}`}
        </div>

        <div className="payment-summary">
          <div className="payment-section-title">📋 Booking Summary</div>
          <div className="payment-summary-content">
            {[
              ["Project", projectLabel],
              ["Floor", floorLabel],
              ["Area", booking?.area ? `${booking.area} sq.ft` : "—"],
            ].map(([k, v]) => (
              <div key={k} className="payment-summary-row">
                <span className="payment-summary-label">{k}</span>
                <span className="payment-summary-value">{v}</span>
              </div>
            ))}
          </div>
        </div>

        {isMilestonePayment && (
          <div className="payment-milestone-card">
            <div className="payment-milestone-header">💳 Milestone Payment</div>
            <ElegantRow label={`${milestone.label} (base)`} value={fmtAmt(milestone.amount)} accent="var(--text-muted)" />
            {(milestone.extra_fees || 0) > 0 && (
              <ElegantRow label="Additional Fees" value={fmtAmt(milestone.extra_fees)} accent="var(--text-muted)" />
            )}
            {(milestone.tax_amount || 0) > 0 && (
              <ElegantRow
                label={`${milestone.tax_label || "Tax"}${milestone.tax_rate > 0 ? ` (${milestone.tax_rate}%)` : ""}`}
                value={fmtAmt(milestone.tax_amount)}
                accent="#f59e0b"
                borderTop
              />
            )}
            <ElegantRow
              label="Milestone Total"
              value={fmtAmt(milestone.total_with_tax ?? milestone.amount)}
              accent={primaryColor}
              bold
              borderTop
            />
          </div>
        )}

        <div className="payment-amount-section">
          <div className="payment-amount-label">{isMilestonePayment ? milestone.label : "Total amount due"}</div>
          <div className="payment-amount-value" style={{ color: primaryColor }}>
            {fmtAmt(downPayment)}
          </div>
        </div>

        {!alreadyPaid && error && (
          <div className="payment-error">
            <span className="payment-error-icon">⚠</span>
            {error}
          </div>
        )}

        <div className="payment-mode-tabs">
          <button
            className={`payment-mode-tab ${payMode === "online" ? "payment-mode-tab-active" : ""}`}
            onClick={() => !alreadyPaid && setPayMode("online")}
            disabled={alreadyPaid}
            style={alreadyPaid ? { opacity: 0.5, cursor: "not-allowed" } : undefined}
          >
            💳 Pay Online
          </button>
          <button
            className={`payment-mode-tab ${payMode === "manual" ? "payment-mode-tab-active" : ""}`}
            onClick={() => !alreadyPaid && setPayMode("manual")}
            disabled={alreadyPaid}
            style={alreadyPaid ? { opacity: 0.5, cursor: "not-allowed" } : undefined}
          >
            🏦 Pay Manually
          </button>
        </div>

        {alreadyPaid ? (
          <div
            style={{
              marginTop: 12,
              padding: "12px 16px",
              borderRadius: 12,
              background: "rgba(34,197,94,0.08)",
              border: "1px solid rgba(34,197,94,0.25)",
              color: "#16a34a",
              fontSize: 13,
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            ✓ This milestone has already been paid — no further action needed.
          </div>
        ) : payMode === "online" ? (
          <>
            {!gateway && (
              <div className="payment-gateway-warning">⚠ No payment gateway configured. Please contact your agent.</div>
            )}
            <button
              className="payment-btn payment-btn-primary"
              onClick={handlePay}
              disabled={paying || !gateway}
              style={{ background: primaryColor }}
            >
              {paying ? (
                <span className="payment-btn-spinner">
                  <span className="spinner"></span>
                  Processing...
                </span>
              ) : (
                providerLabel
              )}
            </button>
          </>
        ) : (
          <ManualPaymentForm
            amountDue={downPayment}
            fmt={fmtAmt}
            submitting={manualSubmitting}
            onSubmit={submitManualPayment}
            onCancel={() => setPayMode("online")}
          />
        )}
      </div>
    </div>
  );
}
